import React from 'react';
import { useState } from 'react';
import NewLetterDashboard from '../components/NewLetterDashboard/NewLetterDashboard';
import "../Utils/dashboard.scss";
import PdfView from '../components/PdfView/PdfView';
import CarrerDashboard from '../components/CarrerDashboard/CarrerDashboard';
import FranchisingDashboard from '../components/FranchisingDashboard/FranchisingDashboard';
import ContactDashboard from '../components/ContactDashboard/ContactDashboard';
import PdfViewDD from '../components/PdfViewDD/PdfViewDD';
import PdfViewDreamDuck from '../components/PdfViewDreamDuck/PdfViewDreamDuck';
import { useNavigate } from 'react-router-dom';

const ProductsPage = () => {
    const [show, setShowModel] = useState("PdfView");
    const navigate = useNavigate();
    const buttonLogout = {
        position: "absolute",
        top: "10px",
        right: "10px",
        padding: "10px 20px",
        borderRadius: "5px",
        cursor: "pointer",
        marginBottom: "20px"
    };

    return (
        <div className='page dashboard' id="page-kontakt" style={{ position: "relative" }}>
            <button style={buttonLogout} onClick={() => {
                localStorage.removeItem("token");
                navigate("/");
            }}>Logout</button>
            <ul className='dashboard-menu'>
               <li><button onClick={() => setShowModel("PdfView")}>Pdf view Captain Candy</button></li>
               <li><button onClick={() => setShowModel("PdfViewDD")}>Pdf view CC & DD</button></li>
               <li><button onClick={() => setShowModel("PdfViewDreamDuck")}>Pdf view Dream Duck</button></li>
               <li><button onClick={() => setShowModel("Letter")}>NewLetter</button></li>
               <li><button onClick={() => setShowModel("Carrer")}>Carrer</button></li>
               <li><button onClick={() => setShowModel("Franchising")}>Franchising</button></li>
               <li><button onClick={() => setShowModel("Contact")}>Contact</button></li>
            </ul>
            <div className='w-100 content-dashboard'>
                {show === "Letter" && <NewLetterDashboard />}
                {show === "PdfView" && <PdfView />}
                {show === "PdfViewDD" && <PdfViewDD />}
                {show === "PdfViewDreamDuck" && <PdfViewDreamDuck />}
                {show === "Carrer" && <CarrerDashboard />}
                {show === "Franchising" && <FranchisingDashboard />}
                {show === "Contact" && <ContactDashboard />}
            </div>
        </div>
    )
}

export default ProductsPage;
